import React from 'react'

const AuditPaneContext = React.createContext()

const AuditPaneContextProvider = ({children}) => {
  const [paneState, setPaneState] = React.useState({
    isOpen: false,
    isDefault: true,
    isSidebarOpen: false,
    isExpandOpen: false,
    activeTab: 'audit',
    modalType: 'New',
    modalFor: 'Audit',
  })

  const setActiveTab = React.useCallback(
    (currentTab, isSidebarOpen, isExpandOpen, isDefault = paneState.isDefault) =>
      setPaneState({
        ...paneState,
        activeTab: currentTab,
        isSidebarOpen: isSidebarOpen,
        isExpandOpen: isExpandOpen,
        isDefault: isDefault,
      }),
    [paneState]
  )

  const resetDefault = React.useCallback(
    () =>
      setPaneState({
        ...paneState,
        isDefault: true,
        isSidebarOpen: false,
        isExpandOpen: false,
      }),
    [paneState]
  )

  const openSidebar = React.useCallback(
    currentTab =>
      setPaneState({
        ...paneState,
        isDefault: false,
        isSidebarOpen: true,
        isExpandOpen: false,
        activeTab: currentTab,
      }),
    [paneState]
  )

  const openExpand = React.useCallback(
    () => setPaneState({...paneState, isDefault: false, isSidebarOpen: false, isExpandOpen: true}),
    [paneState]
  )
  const openAuditExpand = React.useCallback(
    currentTab =>
      setPaneState({
        ...paneState,
        isDefault: false,
        isSidebarOpen: false,
        isExpandOpen: true,
        activeTab: currentTab,
      }),
    [paneState]
  )

  const openModal = React.useCallback(() => setPaneState({...paneState, isOpen: true}), [paneState])

  const editDetail = React.useCallback(
    type => setPaneState({...paneState, modalType: 'edit', isOpen: true, modalFor: type}),
    [paneState]
  )
  const duplicateDetail = React.useCallback(
    type => setPaneState({...paneState, modalType: 'duplicate', isOpen: true, modalFor: type}),
    [paneState]
  )

  const scheduleDetail = React.useCallback(
    () => setPaneState({...paneState, modalType: 'Schedule', isOpen: true, modalFor: 'Audit'}),
    [paneState]
  )

  const closeModal = React.useCallback(
    () => setPaneState({...paneState, isOpen: false, modalType: 'New', modalFor: 'Audit'}),
    [paneState]
  )

  const value = {
    ...paneState,
    setActiveTab,
    resetDefault,
    openSidebar,
    openExpand,
    openModal,
    closeModal,
    editDetail,
    duplicateDetail,
    scheduleDetail,
    openAuditExpand,
  }

  return <AuditPaneContext.Provider value={value}>{children}</AuditPaneContext.Provider>
}

const AuditPaneContextConsumer = AuditPaneContext.Consumer

export {AuditPaneContext, AuditPaneContextProvider, AuditPaneContextConsumer}
